import { render, staticRenderFns } from "./SendToSeproban.vue?vue&type=template&id=396f8b5c&scoped=true"
import script from "./SendToSeproban.vue?vue&type=script&lang=js"
export * from "./SendToSeproban.vue?vue&type=script&lang=js"
import style0 from "./SendToSeproban.vue?vue&type=style&index=0&id=396f8b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396f8b5c",
  null
  
)

export default component.exports